module.exports = __webpack_public_path__ + "img/energymeter.3387f935.svg";